import React, { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { sessionApiClient } from "@planningcenter/cc-api-client"
import { Icon, Loading } from "source/shared/components"

const FormSubmissionVerification = () => {
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = useState(true)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    sessionApiClient
      .post("/people/v2/form_submission_verify", {
        data: {
          attributes: {
            _e: searchParams.get("_e"),
          },
        },
      })
      .then(() => {
        setLoading(false)
        setHasError(false)
      })
      .catch(() => {
        setLoading(false)
        setHasError(true)
      })
  }, [searchParams])

  return loading ? (
    <Loading />
  ) : hasError ? (
    <div className="alert error-alert d-f fd-c ai-c g-1">
      <Icon
        className="fs-0 c-ruby"
        symbol="general#exclamation-triangle"
        aria-hidden
      />
      <h2 className="c-ruby">Uh oh! That link wasn&#39;t valid.</h2>
      <p className="mb-0">Try copying the link directly from your email.</p>
    </div>
  ) : (
    <div className="alert success-alert d-f jc-c ai-c g-1">
      <Icon
        className="fs-3 c-emerald"
        symbol="general#check-circle"
        aria-hidden
      />
      <h2>Thanks for verifying your information!</h2>
    </div>
  )
}

export default FormSubmissionVerification
